import { render, staticRenderFns } from "./ConfigurazioneMedicoEditComponent.vue?vue&type=template&id=b663e0d2"
import script from "./ConfigurazioneMedicoEditComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneMedicoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports